import { type FC } from 'react';
import ErrorFilterLink from '@/components/UI/ErrorFilterLink/ErrorFilterLink';
import { FilterTypes as filterType } from '@/constants/FilterTypes';
import SyncingActive from '@/components/UI/SyncingActive/SyncingActive.tsx';

interface FilterConfig {
  categoryValue: string; // 'sync_status' or 'backfill_status'
  categoryIndex: number; // filter category index, usually 2
}

interface BenchlingSyncStatusAsideProps {
  errorCount: number;
  filterConfig: FilterConfig;
  useTableProps: any;
  testId?: string;
  inStudy?: boolean;
}

const BenchlingSyncStatusAside: FC<BenchlingSyncStatusAsideProps> = ({
  errorCount,
  filterConfig,
  useTableProps,
  testId = 'view-errors-link',
  inStudy = false,
}) => {
  const handleViewErrorsClick = () => {
    // Create a proper filter object for status=failed
    const statusFilter = {
      category: {
        name: 'Status',
        value: filterConfig.categoryValue,
        index: filterConfig.categoryIndex,
      },
      operation: {
        name: filterType.eq, // Use FilterTypes constant: 'is equal to'
        index: 0, // 'eq' operation is at index 0
      },
      option: {
        name: 'Failed',
        value: 'failed',
      },
    };

    useTableProps.apiTable.addFilter(statusFilter);
  };

  return (
    <div className="flex items-center justify-end">
      {errorCount > 0 && (
        <div className={inStudy ? 'mr2 pr2' : ''}>
          <ErrorFilterLink errorCount={errorCount} onViewErrorsClick={handleViewErrorsClick} testId={testId} />
        </div>
      )}
      {inStudy && <SyncingActive />}
    </div>
  );
};

export default BenchlingSyncStatusAside;
